import Repository from './Repository'

const resource = 'riders'

export default {
  getRiders (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  },
  getRider (tenantId, horseId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}/${horseId}`, { params: params })
  },
  getHistoryAssignments (horseId, params) {
    return Repository.get(`${resource}/${horseId}/history-horse-rider`, { params: params })
  },
  getHistoryLesson (horseId, params) {
    return Repository.get(`${resource}/${horseId}/horse-level`, { params: params })
  },
  createRider (tenantId, data) {
    return Repository.post(`tenants/${tenantId}/${resource}`, data)
  },
  updateRider (tenantId, riderId, data) {
    return Repository.patch(`tenants/${tenantId}/${resource}/${riderId}`, data)
  }
}
